import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=fa5aad06&"
import script from "./ReportTable.vue?vue&type=script&lang=js&"
export * from "./ReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=fa5aad06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports